import { getCustomerV2 } from 'utils/CustomersAPIUtils';
export async function getCustomerQuery({ queryKey }) {
    const [, id] = queryKey;
    return getCustomerV2(id);
}
